import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { formatNZD } from "@/lib/api";

export default function ProductCard({ product, delay = 0, eager = false }) {
  return (
    <Reveal delay={delay} className="h-full">
      <Link
        to={`/product/${product.slug}`}
        data-testid={`product-card-${product.slug}`}
        className="group flex h-full flex-col overflow-hidden rounded-2xl border border-black/10 bg-white transition-all duration-300 hover:border-volt/50 hover:shadow-[0_0_60px_-16px_rgba(0,87,255,0.35)]"
      >
        <div className="relative aspect-[4/3] overflow-hidden bg-surface">
          <img
            src={product.images[0]}
            alt={product.name}
            loading={eager ? "eager" : "lazy"}
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
          <span className="absolute left-4 top-4 rounded-full border border-volt/30 bg-white/85 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-volt backdrop-blur-sm">
            {product.badge}
          </span>
        </div>
        <div className="flex flex-1 items-end justify-between gap-4 p-6">
          <div>
            <h3 className="font-display text-xl font-extrabold tracking-tight text-ink">
              {product.name}
            </h3>
            <p className="mt-2 max-w-sm text-sm leading-relaxed text-zinc-600">
              {product.short_description}
            </p>
          </div>
          <div className="shrink-0 text-right">
            <p className="eyebrow mb-1">From</p>
            <p className="font-mono text-lg font-bold text-volt">
              {formatNZD(product.base_price)}
            </p>
            <span className="mt-2 inline-flex items-center gap-1 font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 transition-colors duration-200 group-hover:text-ink">
              Configure
              <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </span>
          </div>
        </div>
      </Link>
    </Reveal>
  );
}
